import {
  Autocomplete,
  Box,
  FormControl,
  FormHelperText,
  Stack,
  TextField,
} from "@mui/material";
import React, { Fragment } from "react";
import { Controller, FormProvider, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import RegSubmit from "../components/RegSubmit";
import PasswordForm from "./PasswordForm";
import { MobileDatePicker } from "@mui/x-date-pickers";
const height = "50vh";
const firstPage = [
  {
    label: "Name",
    val: "firstName",
    required: true,
  },
  {
    label: "LastName",
    val: "lastName",
    required: true,
  },
  {
    label: "PhoneNumber",
    val: "phoneNumber",
    required: true,
  },
];
const secondPage = [
  {
    label: "Email",
    val: "email",
    required: true,
  },
  {
    label: "Username",
    val: "username",
    required: true,
  },
];

function StackBody({ children }) {
  return (
    <Stack
      mt={2}
      minHeight={height}
      justifyContent={"center"}
      alignItems={"center"}
      spacing={4}
    >
      {children}
    </Stack>
  );
}

export default function UserRegBody({ activeStep, isLoading, data }) {
  const { t } = useTranslation();
  const methods = useFormContext();
  const { errors } = methods.formState;
  return (
    <Fragment>
      {activeStep == 0 ? (
        <StackBody>
          {firstPage.map((field) => (
            <TextField
              required={field.required}
              key={field.val}
              fullWidth
              label={t(field.label)}
              inputProps={{
                maxLength: 120,
                "data-testid": `auth.signup.${field.val}-input`,
              }}
              error={!!errors[field.val]}
              helperText={errors[field.val]?.message}
              {...methods.register(field.val)}
            />
          ))}
          <Controller
            name="dob"
            control={methods.control}
            defaultValue={null}
            render={({ field }) => (
              <MobileDatePicker
                format="DD/MM/YYYY"
                sx={{ width: "100%" }}
                disableFuture
                openTo={"year"}
                label={t("DoB")}
                value={field.value}
                onChange={(newValue) => field.onChange(newValue)}
                renderInput={(params) => <TextField {...params} />}
                slotProps={{
                  textField: {
                    inputProps: { "data-testid": "auth.signup.dob-input" },
                  },
                }}
              />
            )}
          />
        </StackBody>
      ) : (
        <StackBody>
          {secondPage.map((field) => (
            <TextField
              key={field.val}
              required={field.required}
              fullWidth
              label={t(field.label)}
              inputProps={{
                maxLength: 120,
                "data-testid": `auth.signup.${field.val}-input`,
              }}
              error={!!errors[field.val]}
              helperText={errors[field.val]?.message}
              {...methods.register(field.val)}
            />
          ))}

          {/* Clinic Selection Field */}
          <FormControl error={!!errors.clinic} fullWidth>
            <Controller
              name={"clinic"}
              control={methods.control}
              {...methods.register("clinic")}
              render={({ field }) => (
                <Autocomplete
                  fullWidth
                  size="medium"
                  defaultValue={""}
                  {...field}
                  value={field.value ?? null}
                  onChange={(e, value) => {
                    field.onChange(value);
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  options={data}
                  getOptionLabel={(option) =>
                    `${option.title} - ${option.streetAddress}, ${option.city}`
                  }
                  renderOption={(props, option) => (
                    <Box {...props} key={option.id}>
                      {option.title} - {option.streetAddress}, {option.city}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      error={!!errors?.clinic}
                      label={t("Clinic")}
                      inputProps={{
                        ...params.inputProps,
                        "data-testid": "auth.signup.clinic-input",
                      }}
                    />
                  )}
                  clearText={t("Clear")}
                  closeText={t("Close")}
                  openText={t("Open")}
                />
              )}
            />
            {errors?.clinic?.message && (
              <FormHelperText>{t("PleaseSelectClinic")}</FormHelperText>
            )}
          </FormControl>
          <FormProvider {...methods}>
            <PasswordForm />
          </FormProvider>
          <RegSubmit isLoading={isLoading} />
        </StackBody>
      )}
    </Fragment>
  );
}
